/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { ApiEntity } from '@backstage/catalog-model';
import { createApiRef } from '@backstage/core-plugin-api';

import { ApiDefinitionWidget } from './components/ApiDefinitionCard/ApiDefinitionWidget';
import { ApiGovernanceWidget } from './components/ApiGovernanceCard/ApiGovernanceWidget';

/** @public */
export const apiDocsConfigRef = createApiRef<ApiDocsConfig>({
  id: 'plugin.api-docs.config',
});

/** @public */
export interface ApiDocsConfig {
  getApiDefinitionWidget: (
    apiEntity: ApiEntity,
  ) => ApiDefinitionWidget | undefined;
  getApiGovernanceWidget: (
    apiEntity: ApiEntity,
  ) => ApiGovernanceWidget | undefined;
}
